import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { I18nModule } from '@spartacus/core'
import { SpinnerModule } from '@spartacus/storefront'
import { CancelDispenserAgreementModalComponent } from './cancel-dispenser-agreement-modal.component'

@NgModule({
  declarations: [CancelDispenserAgreementModalComponent],
  imports: [CommonModule, I18nModule, RouterModule, SpinnerModule]
})
export class CancelDispenserAgreementModalModule {}
